// removed by extract-text-webpack-plugin
module.exports = {"divider":"styles__divider___6PyL7"};


//////////////////
// WEBPACK FOOTER
// ./app/shared/components/divider/styles.css
// module id = LOUu
// module chunks = 2